import { Box } from '@mui/material';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { _ } from '/@/locale';
import { setSelectedCropRotation } from '/@/store/carbon-calculator-BR/actions';
import { getCropRotation, getCropRotationSelected } from '/@/store/carbon-calculator-BR/selectors';
import { isPhone } from '/@/utils';
import ToggleGroup from '/@/v3/components/forms/toggle-group';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';
@connect(
    (state, props) => {
        return {
            options: getCropRotation(state),
            selectedCropRotation: getCropRotationSelected(state),
        };
    },
    (dispatch) =>
        bindActionCreators(
            {
                setSelectedCropRotation,
            },
            dispatch
        )
)
@autobind
export default class Campaign extends Component {
    static propTypes = {
        onClick: PropTypes.func,
        selected: PropTypes.bool,
        type: PropTypes.oneOf(['check', 'text']),
        number: PropTypes.number,
        onChange: PropTypes.func,
        minimizeCampaign: PropTypes.func,
        error: PropTypes.bool,
    };

    static defaultProps = {
        onChange: () => {},
    };

    componentWillUnmount() {
        this.props.setSelectedCropRotation([]);
    }

    render() {
        const check = classNames(styles.checkHeader, this.props.error && styles.error);

        return (
            <Box
                sx={
                    this.props.selected && !this.props.error && { border: (t) => `1px solid ${t.palette.primary.main}` }
                }
            >
                <div className={styles.campaign}>
                    {this.props.type === 'text' ? (
                        <div>
                            <div
                                className={styles.dropdownHeader}
                                onClick={
                                    this.props.selected
                                        ? isPhone()
                                            ? this.props.minimizeCampaign
                                            : this.props.onClick
                                        : this.props.onClick
                                }
                            >
                                <Title size='md'>
                                    {_('Año')} {this.props.number}
                                </Title>
                                <div className={styles.plus}>{this.props.selected ? (isPhone() ? '-' : '+') : '+'}</div>
                            </div>
                            <div>{this.props.children}</div>
                        </div>
                    ) : (
                        <div className={check}>
                            <Title
                                className={classNames(styles.title, this.props.error && styles.errorTitle)}
                                size='md'
                            >
                                {_('Rotación de cultivos')}
                            </Title>
                            <ToggleGroup
                                type='radio'
                                boolean
                                value={this.props.selectedCropRotation}
                                options={this.props.options}
                                onChange={(value) => {
                                    this.props.setSelectedCropRotation(value);
                                    this.props.onChange(value);
                                }}
                                small
                                color='black'
                                className={styles.toogle}
                            />
                        </div>
                    )}
                </div>
            </Box>
        );
    }
}
